(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["beyond-quiz-funnel"] && !Shopify.designMode) return;
  try {
    (function() {
    const root = document.querySelector('[data-lc-quiz]');
    if (!root) return;

    const klaviyoKey = root.dataset.klaviyoKey;
    const klaviyoListId = root.dataset.klaviyoList;
    const n8nWebhook = root.dataset.n8nWebhook;

    const progressBar = root.querySelector('[data-lc-progress]');
    const obiettivoSlug = {
    'Aumentare la massa muscolare': 'massa',
    'Perdere peso e tonificare': 'peso',
    'Migliorare energia e resistenza': 'energia',
    'Rafforzare il sistema immunitario': 'benessere'
    };

    // Hash SHA-256 (richiesto da Meta per dati PII)
    async function sha256(str) {
    if (!str) return '';
    const buf = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(str.toLowerCase().trim()));
    return Array.from(new Uint8Array(buf)).map(b => b.toString(16).padStart(2, '0')).join('');
    }

    // Legge un cookie per nome
    function getCookie(name) {
    const m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : '';
    }

    // Costruisce fbc da fbclid se presente in URL e non c'è il cookie
    function getFbc() {
    const cookie = getCookie('_fbc');
    if (cookie) return cookie;
    const fbclid = new URLSearchParams(window.location.search).get('fbclid');
    if (fbclid) return `fb.1.${Date.now()}.${fbclid}`;
    return '';
    }

    const transitionEl = root.querySelector('[data-lc-transition]');
    const transitionSpinner = root.querySelector('[data-lc-transition-spinner]');
    const transitionIcon = root.querySelector('[data-lc-transition-icon]');
    const transitionTitle = root.querySelector('[data-lc-transition-title]');
    const transitionText = root.querySelector('[data-lc-transition-text]');

    const steps = Array.from(root.querySelectorAll('[data-lc-step]'));
    const totalQuestions = steps.filter(s => /^\d+$/.test(s.dataset.lcStep)).length;

    const answers = {};
    let currentIndex = 0;

    /* ============================================================
       WAITING SCREEN MAP
    ============================================================ */
    const transitions = {
      '1': {
        duration: 2400,
        type: 'advice',
        getContent: (val) => {
          const map = {
            'Aumentare la massa muscolare': {
              icon: '💪',
              title: 'Massa muscolare in vista',
              text: 'Le proteine di qualità e una recovery curata sono i due pilastri. Costruiremo il piano attorno a questo.'
            },
            'Perdere peso e tonificare': {
              icon: '🔥',
              title: 'Ricomposizione corporea',
              text: 'Più che "perdere peso", l\'obiettivo è preservare massa magra mentre il grasso scende. Approccio diverso, risultati migliori.'
            },
            'Migliorare energia e resistenza': {
              icon: '⚡',
              title: 'Energia da costruire',
              text: 'L\'energia non si "carica" con un caffè. Vitamine del gruppo B, ferro e magnesio fanno la vera differenza nel lungo periodo.'
            },
            'Rafforzare il sistema immunitario': {
              icon: '🛡️',
              title: 'Difese in primo piano',
              text: 'Vitamina C, D, zinco e probiotici lavorano in squadra. Vediamo come integrarli nel tuo stile di vita.'
            }
          };
          return map[val] || { icon: '✨', title: 'Personalizziamo', text: 'Adattiamo i consigli al tuo obiettivo.' };
        }
      },
      '2': {
        duration: 1300,
        type: 'tip',
        getContent: (val) => {
          const map = {
            'Palestra/Fitness': { icon: '🏋️', title: 'Forza e ipertrofia', text: '' },
            'Corsa/Bicicletta': { icon: '🏃', title: 'Endurance ed elettroliti', text: '' },
            'Sport di squadra': { icon: '⚽', title: 'Esplosività e recupero', text: '' },
            'Yoga/Pilates': { icon: '🧘', title: 'Flessibilità e mobilità', text: '' }
          };
          return map[val] || { icon: '🎯', title: 'Annotato', text: '' };
        }
      },
      '3': {
        duration: 2200,
        type: 'advice',
        getContent: (val) => {
          const map = {
            '1-2 volte': {
              icon: '🌱',
              title: 'Approccio graduale',
              text: 'Con 1-2 sessioni settimanali, l\'integrazione di base (multivitaminico + omega-3) ti porta lontano.'
            },
            '3-4 volte': {
              icon: '🔥',
              title: 'Frequenza ottimale',
              text: 'Il punto dolce. Qui l\'integrazione mirata fa la differenza tra "alleno" e "progredisco".'
            },
            '5-6 volte': {
              icon: '⚡',
              title: 'Atleta in attivo',
              text: 'Volume alto = recovery prioritaria. Senza, il sovrallenamento è dietro l\'angolo.'
            },
            'Tutti i giorni': {
              icon: '💯',
              title: 'Massimo impegno',
              text: 'Ogni giorno richiede una strategia di nutrizione e recovery curata al millimetro. Te la costruiamo noi.'
            }
          };
          return map[val] || { icon: '📊', title: 'Calibriamo', text: 'Adattiamo il piano alla tua frequenza.' };
        }
      },
      '4': {
        duration: 1300,
        type: 'tip',
        getContent: () => ({ icon: '✅', title: 'Profilo aggiornato', text: '' })
      },
      '5': {
        duration: 1300,
        type: 'tip',
        getContent: (val) => {
          const map = {
            'Pre-workout': { icon: '🚀', title: 'Pre-workout window', text: '' },
            'Post-workout': { icon: '🔋', title: 'Finestra anabolica', text: '' },
            'Mattina': { icon: '☀️', title: 'Routine mattutina', text: '' },
            'Sera': { icon: '🌙', title: 'Recupero notturno', text: '' }
          };
          return map[val] || { icon: '⏰', title: 'Timing salvato', text: '' };
        }
      },
      '6': {
        duration: 2300,
        type: 'advice',
        getContent: (val) => {
          const map = {
            'Mancanza di energia': {
              icon: '🪫',
              title: 'Energia che cala',
              text: 'Spesso non è "stanchezza" ma carenze nascoste: ferro, B12, vitamina D. Le valuteremo tutte.'
            },
            'Recupero lento': {
              icon: '⏳',
              title: 'Recupero da accelerare',
              text: 'Magnesio, BCAA e un\'idratazione corretta possono dimezzare i tempi di recovery. Ne parliamo nel piano.'
            },
            'Motivazione': {
              icon: '🎯',
              title: 'Costanza prima di tutto',
              text: 'A volte la "mancanza di motivazione" è in realtà mancanza di energia fisica. Aggiustiamo il corpo, la mente segue.'
            },
            'Immunitario': {
              icon: '🛡️',
              title: 'Difese da rafforzare',
              text: 'Stress + allenamento intenso possono abbassare le difese. Lo affronteremo con un protocollo specifico.'
            }
          };
          return map[val] || { icon: '🎯', title: 'Sfida identificata', text: 'Lavoreremo proprio su questo.' };
        }
      },
      '7': {
        duration: 2600,
        type: 'building',
        getContent: () => ({
          icon: null,
          title: 'Sto costruendo il tuo percorso...',
          text: 'Sto incrociando le tue risposte per personalizzare i consigli. Ancora pochi secondi.'
        })
      }
    };

    /* ============================================================
       NAVIGATION
    ============================================================ */
    function showStep(index) {
      steps.forEach(s => s.classList.remove('is-active'));
      const step = steps[index];
      if (step) {
        step.classList.add('is-active');
        const rect = root.getBoundingClientRect();
        if (rect.top < 0) {
          root.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
      updateProgress(index);
      currentIndex = index;
    }

    function updateProgress(index) {
      const step = steps[index];
      if (!step) return;
      const stepKey = step.dataset.lcStep;
      let pct = 0;
      if (/^\d+$/.test(stepKey)) {
        pct = (parseInt(stepKey, 10) / (totalQuestions + 1)) * 100;
      } else if (stepKey === 'form') {
        pct = (totalQuestions / (totalQuestions + 1)) * 100;
      } else if (stepKey === 'result') {
        pct = 100;
      }
      progressBar.style.width = pct + '%';
    }

    function showTransition(stepKey, value, callback) {
      const config = transitions[stepKey];
      if (!config) { callback(); return; }

      const content = config.getContent(value);
      transitionTitle.textContent = content.title || '';
      transitionText.textContent = content.text || '';

      if (config.type === 'building') {
        transitionSpinner.hidden = false;
        transitionIcon.hidden = true;
      } else if (config.type === 'tip') {
        transitionSpinner.hidden = true;
        transitionIcon.hidden = false;
        transitionIcon.textContent = content.icon || '✨';
      } else {
        transitionSpinner.hidden = false;
        transitionIcon.hidden = true;
        setTimeout(() => {
          transitionSpinner.hidden = true;
          transitionIcon.hidden = false;
          transitionIcon.textContent = content.icon || '💡';
        }, 800);
      }

      transitionEl.hidden = false;
      setTimeout(() => {
        transitionEl.hidden = true;
        callback();
      }, config.duration);
    }

    /* ============================================================
       OPTIONS HANDLING
    ============================================================ */
    root.querySelectorAll('.lc-option').forEach(opt => {
      opt.addEventListener('click', () => {
        const step = opt.closest('[data-lc-step]');
        const key = step.dataset.lcKey;
        const value = opt.dataset.lcValue;

        step.querySelectorAll('.lc-option').forEach(o => o.classList.remove('is-selected'));
        opt.classList.add('is-selected');

        answers[key] = value;

        const stepKey = step.dataset.lcStep;
        const nextIndex = currentIndex + 1;

        showTransition(stepKey, value, () => {
          showStep(nextIndex);
        });
      });
    });

    /* ============================================================
       FORM SUBMIT + KLAVIYO
    ============================================================ */
    const form = root.querySelector('[data-lc-form]');
    const submitBtn = form.querySelector('.lc-submit');
    const submitLabel = form.querySelector('.lc-submit__label');
    const submitLoader = form.querySelector('.lc-submit__loader');
    const errorBox = root.querySelector('[data-lc-form-error]');

    form.addEventListener('submit', async (e) => {
      e.preventDefault();

      const name = form.name.value.trim();
      const email = form.email.value.trim();
      const consent = form.consent.checked;

      errorBox.hidden = true;

      if (!name || !email || !consent) {
        errorBox.textContent = 'Compila tutti i campi e accetta la privacy policy.';
        errorBox.hidden = false;
        return;
      }

      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        errorBox.textContent = 'Inserisci un indirizzo email valido.';
        errorBox.hidden = false;
        return;
      }

      submitBtn.disabled = true;
      submitLabel.textContent = 'Invio in corso...';
      submitLoader.hidden = false;

      try {
        // Costruisci dati per Meta CAPI
        const slug = obiettivoSlug[answers.obiettivo] || '';
        const eventId = 'lead_' + Date.now() + '_' + Math.random().toString(36).slice(2, 10);

        const firstName = name.split(' ')[0] || '';
        const lastName = name.split(' ').slice(1).join(' ') || '';

        const [emHash, fnHash, lnHash, externalId] = await Promise.all([
            sha256(email),
            sha256(firstName),
            sha256(lastName),
            sha256(email)
        ]);

        const fbp = getCookie('_fbp');
        const fbc = getFbc();

        // 1. Pixel client-side (browser)
        if (typeof fbq === 'function') {
            fbq('track', 'Lead', {
            content_name: 'Lifecode Quiz',
            content_category: slug,
            obiettivo: answers.obiettivo || ''
            }, { eventID: eventId });
        }

        // 2. Webhook N8N: gestisce Klaviyo subscription + Meta CAPI
        fetch(n8nWebhook, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            keepalive: true,
            body: JSON.stringify({
            // Lead info
            lead: {
                name: name,
                first_name: firstName,
                last_name: lastName,
                email: email,
                consent: true,
                source: 'Lifecode Quiz Funnel',
                timestamp: new Date().toISOString()
            },
            // Risposte quiz (per Klaviyo properties)
            quiz: {
                obiettivo: answers.obiettivo || '',
                obiettivo_slug: slug,
                sport: answers.sport || '',
                frequenza: answers.frequenza || '',
                esperienza: answers.esperienza || '',
                momento: answers.momento || '',
                sfida: answers.sfida || '',
                alimentazione: answers.alimentazione || ''
            },
            // Dati per Meta CAPI (tutto pronto, già hashato dove serve)
            meta_capi: {
                event_name: 'Lead',
                event_id: eventId,
                event_time: Math.floor(Date.now() / 1000),
                event_source_url: window.location.href,
                action_source: 'website',
                user_data: {
                em: emHash,
                fn: fnHash,
                ln: lnHash,
                external_id: externalId,
                fbp: fbp,
                fbc: fbc,
                client_user_agent: navigator.userAgent
                // client_ip_address lo aggiunge N8N dal $request.headers
                },
                custom_data: {
                content_name: 'Lifecode Quiz',
                content_category: slug,
                obiettivo: answers.obiettivo || ''
                }
            }
            })
        }).catch(err => console.warn('[LC Quiz] N8N webhook failed:', err));

        // 3. Redirect immediato (non aspettiamo N8N: fire-and-forget)
        const params = new URLSearchParams({ nome: name, obiettivo: slug });
        window.location.href = '/pages/risultato?' + params.toString();

        } catch (err) {
        console.error('[LC Quiz] Submit error:', err);
        errorBox.textContent = 'Si è verificato un errore. Riprova tra qualche istante.';
        errorBox.hidden = false;
        submitBtn.disabled = false;
        submitLabel.textContent = 'Visualizza il mio percorso';
        submitLoader.hidden = true;
        }
    });

    /* ============================================================
       KLAVIYO INTEGRATION
    ============================================================ */
    async function sendToKlaviyo({ name, email, answers }) {
      const customProps = {
        'Obiettivo di benessere': answers.obiettivo || '',
        'Sport praticato': answers.sport || '',
        'Frequenza allenamento': answers.frequenza || '',
        'Esperienza integratori': answers.esperienza || '',
        'Momento assunzione': answers.momento || '',
        'Sfida principale': answers.sfida || '',
        'Alimentazione': answers.alimentazione || ''
      };

      const payload = {
        data: {
          type: 'subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                  first_name: name,
                  properties: customProps
                }
              }
            },
            custom_source: 'Lifecode Quiz Funnel'
          },
          relationships: {
            list: {
              data: { type: 'list', id: klaviyoListId }
            }
          }
        }
      };

      const url = `https://a.klaviyo.com/client/subscriptions/?company_id=${encodeURIComponent(klaviyoKey)}`;

      const res = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'revision': '2024-10-15'
        },
        body: JSON.stringify(payload)
      });

      if (!res.ok && res.status !== 202) {
        const errText = await res.text().catch(() => '');
        throw new Error(`Klaviyo ${res.status}: ${errText}`);
      }

      return true;
    }

    /* ============================================================
       INIT
    ============================================================ */
    showStep(0);
  })();
  } catch(e) { console.error(e); }
})();

})();
